import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ORGANIZATION_STATUSES } from "@/api/types";
import { OrganizationsPage } from "@/features/organizations/organizations-page";
import { baseListSearch, optionalDate, optionalEnum, optionalInt, optionalString } from "@/lib/list-state";

export const organizationsSearch = z.object({
  ...baseListSearch,
  status: optionalEnum(ORGANIZATION_STATUSES),
  plan: optionalString,
  createdFrom: optionalDate,
  createdTo: optionalDate,
  minStores: optionalInt,
  activity: optionalEnum(["active_24h", "active_7d", "inactive_30d"] as const),
  preview: optionalString,
});

export const Route = createFileRoute("/_authenticated/organizations/")({
  validateSearch: organizationsSearch,
  head: () => ({ meta: [{ title: "Organizations · Rogue Admin" }] }),
  component: OrganizationsPage,
});
